import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { StepStatus, StepProps } from "../../../../../common/types/Stepper";
import { userStyles } from '../../../../styles';
import _ from 'lodash';
import { contentRequestAccordianActions } from '../../../../reducers/contentRequestAccordianState';
import MyPATExpansionStep from "../../../../../common/MyPATExpansionStep";
import TestCard from '../../../../components/TestBar';
import LinearProgress from '@material-ui/core/LinearProgress';
import contentRequestServices from '../../../../services/contentRequestServices';
import { Grid, Checkbox, Modal, WithStyles, withStyles } from '@material-ui/core';
import RequestReviewContainer from '../../../RequestReviewContainer';
import { showMsg } from '../../../../../user-management/actions/miniLibrariesActions';
import { withRouter } from 'react-router-dom';
interface TestComponentProps extends WithStyles<typeof userStyles> {
    expansionRoot?: any,
    questionData: any,
    requestId: string,
    history: any,
    setAccordianState: Function,
    accordianState: any,
    accordianTouched: any,
    setAccordingTouchIndex: Function,
    setAccordianTouchWhileCreate: Function,
    accordianCreateTouched: any,
    handleChooseFromLibrary: Function,
    isComingFromTestComponent: boolean,
    isTabOpened: boolean,
    setIsTabOpened: Function,
    setProgressBarForTest: Function,
    progressBarForTest: any,
    contentRequestId: string,
    testDetails: any,
    totalCount: number,
    setTestAccordian: Function,
    accordianTest: any,
    subHeading: string,
    type: string,
    isTestRequest: boolean,
    contentRequestData: any,
    overallDone: any;
    setRemoveUnresolvedFeedbackCountForTest: Function;
    removeUnresolvedFeedbackCountForTest: number;
    match: any;
    showMsg: any;
    setFeedbackClose: Function;
    
}
interface TestComponentState {
    accordianTouchState: any,
    accordianCreateTouched: any,
    selectQuestionDialogOpen: boolean,
    showRequestContainer: boolean;
    sliderData: any;
    selectedContentId: string,
    currentQuestionNumber: number,
    currentTestNumber: number,
    contentQuestionType: string,
    contentQuestionCode: string,
    fromURL: string,
}


class TestComponent extends Component<TestComponentProps, TestComponentState> {
    constructor(props: TestComponentProps) {
        super(props);
        this.state = {
            accordianTouchState: [...this.props.accordianTouched],
            accordianCreateTouched: { ...this.props.accordianCreateTouched },
            selectQuestionDialogOpen: false,
            showRequestContainer: false,
            sliderData: {},
            selectedContentId: '',
            currentQuestionNumber: 1,
            currentTestNumber: 1,
            contentQuestionType: '',
            contentQuestionCode: '',
            fromURL: 'preview',
        }
        this.contentChanged = this.contentChanged.bind(this);
        this.closeReviewContainer = this.closeReviewContainer.bind(this);
    }

    contentChanged(contentId: string, numberValue: number, type: string, fromURL: string) {
        this.setState({
            selectedContentId: contentId,
            currentTestNumber: numberValue,
            fromURL: fromURL
        })
    }

    closeReviewContainer() {
        const { contentRequestData } = this.props;
        this.setState({
            showRequestContainer: false,
            sliderData: {},
            selectedContentId: '',
            currentQuestionNumber: 1,
            currentTestNumber: 1,
            fromURL: 'preview',
        }, ()=>{
            this.props.setFeedbackClose({ booleanValue: true })
            this.props.history.push(`/contentRequest/owner-task/${contentRequestData._id}/creator`);

         }
        )
    }
    onFeedbackClickFromCreator(test: any) {
        let unResolvedContent = JSON.parse(JSON.stringify(test.requestInfo.details.testDetails.contentRequestItemsId));
        let unResolvedCountData = unResolvedContent.contents.filter((ele: any) => ele.content_id.unresolvedFeedbackCount > 0);
        unResolvedContent.contents = unResolvedCountData;
        this.setState({
            showRequestContainer: true,
            sliderData: unResolvedContent,
            selectedContentId: `${unResolvedContent.contents[0].content_id._id}testpapers`
        })
    }
    handleTestState = (index: number, accordianIndex: number) => {
        const accordianState = accordianIndex;
        const questionIndex = index + 1;
        this.setState({
            accordianCreateTouched: {
                accordianIndex: accordianState,
                questionIndex: questionIndex
            }
        }, () => {
            const { setAccordianTouchWhileCreate } = this.props;
            const { accordianCreateTouched = {} } = this.state;
            setAccordianTouchWhileCreate(accordianCreateTouched)
        });
    }
    isTestResetable = async () => {
        const { match } = this.props;
        const { params: { contentRequestId = '', role = '' } = {} } = match;
        const result = await contentRequestServices.getOwnerTaskByRole(contentRequestId, role)
        const { requestInfo: { type = '', details: { testDetails = {} } = {} } = {} } = result;
        return this.checkIfSubmitForEvalutionIsDone(testDetails);
    }
    checkIfSubmitForEvalutionIsDone = (testDetails: any) => {
        const { contentRequestItemsId = null } = testDetails;
        if (contentRequestItemsId) {
            const { overallStatus = {} } = contentRequestItemsId;
            const isOverAllJobCompleted = overallStatus.creator.isJobCompleted;
            return isOverAllJobCompleted;
        }
    }

    handleResetTest = async (resetIndexQuestion: number, resetIndexAccordian: number, contentRequestItemId: string) => {
        const isTestResetable = await this.isTestResetable();
        if (!isTestResetable) {
            const { accordianTest, setAccordingTouchIndex, setProgressBarForTest, progressBarForTest, setTestAccordian } = this.props;
            let newAccordianTouchState = [...accordianTest];
            const { testContent = [] } = newAccordianTouchState[resetIndexAccordian];
            let updateTestContent = [...testContent];
            const findTestIndex = testContent.findIndex((ele: any) => ele.testIndex === resetIndexQuestion);
            const contentID = updateTestContent[findTestIndex].attachedQuestions.content_Id.substring(0, 24);
            try {
                const saveResponse = contentRequestServices.resetQuestions(contentRequestItemId, contentID);

            } catch (error) {
            };
            const isJobCompleted = updateTestContent[findTestIndex].attachedQuestions.isJobCompleted;
            updateTestContent[findTestIndex] = {
                ...updateTestContent[findTestIndex],
                attachedQuestions: {
                    contentId: '',
                    content_Id: '',
                    isJobCompleted: false,
                    isTouched: true
                }
            }
            
            newAccordianTouchState[resetIndexAccordian] = {
                ...newAccordianTouchState[resetIndexAccordian],
                testContent: [
                    ...updateTestContent,
                ]
            }
            const { count } = progressBarForTest;
            setTestAccordian(newAccordianTouchState);
            isJobCompleted && setProgressBarForTest({ count: count - 1 });
            return true;
        }
        else {
            this.props.showMsg('test cannot be reset', 'error');
            return false;
        }
    }

    handleResetTestForUnresolvedFeedbackCount = (resetIndexQuestion: number, resetIndexAccordian: number, contentRequestItemId: string) => {
        const { accordianTest, setAccordingTouchIndex, setProgressBarForTest, progressBarForTest, setTestAccordian } = this.props;
        let newAccordianTouchState = [...accordianTest];
        const { testContent = [] } = newAccordianTouchState[resetIndexAccordian];
        let updateTestContent = [...testContent];
        const findTestIndex = testContent.findIndex((ele: any) => ele.testIndex === resetIndexQuestion);
        const contentID = updateTestContent[findTestIndex].attachedQuestions.content_Id.substring(0, 24);
        const previousVersion = Object.keys(updateTestContent[findTestIndex]['attachedQuestions'].previousVersion).length ? updateTestContent[findTestIndex]['attachedQuestions'].previousVersion :
        updateTestContent[findTestIndex]['attachedQuestions'];
        updateTestContent[findTestIndex] = {
            ...updateTestContent[findTestIndex],
            attachedQuestions: {
                contentId: '',
                content_Id: '',
                isJobCompleted: false,
                isTouched: true,
                unresolvedFeedbackCount: updateTestContent[findTestIndex]['attachedQuestions'].unresolvedFeedbackCount,
                previousVersion: {
                    ...previousVersion
                }
            }
        }

        newAccordianTouchState[resetIndexAccordian] = {
            ...newAccordianTouchState[resetIndexAccordian],
            testContent: [
                ...updateTestContent,
            ]
        }
        const { count } = progressBarForTest;
        setTestAccordian(newAccordianTouchState);
        setProgressBarForTest({ count: count - 1 });
    }

    handleSaveTest = (testIndex: number, accordianIndex: number) => {
        const { accordianTest, setAccordingTouchIndex, setProgressBarForTest, progressBarForTest, setTestAccordian } = this.props;
        let newAccordianTouchState = [...accordianTest];

        const { testContent = [] } = newAccordianTouchState[accordianIndex];
        let updateTestContent = [...testContent];
        const findTestIndex = testContent.findIndex((ele: any) => ele.testIndex === testIndex);

        updateTestContent[findTestIndex] = {
            ...updateTestContent[findTestIndex],
            attachedQuestions: {
                ...updateTestContent[findTestIndex]['attachedQuestions'],
                isJobCompleted: true,
                unresolvedFeedbackCount: 0,
            }
        }
        newAccordianTouchState[accordianIndex] = {
            ...newAccordianTouchState[accordianIndex],
            testContent: [
                ...updateTestContent,
            ]
        }
        setTestAccordian(newAccordianTouchState);
    }

    handleSaveTestForUnresolvedCount = (testIndex: number, accordianIndex: number) => {
        const { accordianTest, setAccordingTouchIndex, setProgressBarForTest, progressBarForTest, setTestAccordian } = this.props;
        let newAccordianTouchState = [...accordianTest];

        const { testContent = [] } = newAccordianTouchState[accordianIndex];
        let updateTestContent = [...testContent];
        const findTestIndex = testContent.findIndex((ele: any) => ele.testIndex === testIndex);

        updateTestContent[findTestIndex] = {
            ...updateTestContent[findTestIndex],
            attachedQuestions: {
                ...updateTestContent[findTestIndex]['attachedQuestions'],
                isJobCompleted: true,
                unresolvedFeedbackCount: 0,
            }
        }
        newAccordianTouchState[accordianIndex] = {
            ...newAccordianTouchState[accordianIndex],
            testContent: [
                ...updateTestContent,
            ]
        }
        setTestAccordian(newAccordianTouchState);
        localStorage.setItem('overallData', 'true');
    }

    addTest = (type: string, accordianIndex: number) => {
        const { requestId, history, accordianTest, contentRequestId, isTestRequest, testDetails, contentRequestData } = this.props;
        const { testContent } = accordianTest[accordianIndex];
        return testContent && testContent.map((element: any) => {
            const { testIndex = 0, attachedQuestions = {} } = element;
            return (
                <div>
                    <TestCard count={testIndex} type={type}
                        handleResetTest={() => this.handleResetTest(testIndex, accordianIndex, testDetails.contentRequestItemsId._id)}
                        handleResetTestForUnresolvedFeedbackCount={() => this.handleResetTestForUnresolvedFeedbackCount(testIndex, accordianIndex, testDetails.contentRequestItemsId._id)}
                        attachedQuestions={attachedQuestions}
                        requestId={requestId}
                        handleTestState={() => this.handleTestState(testIndex - 1, accordianIndex)}
                        history={history}
                        isTestRequest={isTestRequest}
                        testDetails={testDetails}
                        contentRequestId={contentRequestData._id}
                        handleSaveTest={() => this.handleSaveTest(testIndex, accordianIndex)}
                        handleSaveTestForUnresolvedCount={() => this.handleSaveTestForUnresolvedCount(testIndex, accordianIndex)}
                    />
                </div>
            )
        })
    }
    handleStatusOfTest(length: number, count: number) {
        let status: any;
        const { overallDone } = this.props;
        if (length === count && overallDone) {
            status = StepStatus.DONE;
        } else if (length !== 0) {
            status = StepStatus.INPROGRESS;
        } else {
            status = StepStatus.PENDING;
        }
        return status;
    }
    subHeading = (count: number) => {
        const { questionData = [] } = this.props;
        return questionData && questionData.length ? `${count} Question` : `${count} Test`
    }



    render = () => {
        const { accordianTest, totalCount, testDetails: { type = '', description = "" } = {}, progressBarForTest, contentRequestData, overallDone, classes } = this.props;
        const { testContent = [] } = accordianTest[0];
        const { showRequestContainer, sliderData, selectedContentId, currentQuestionNumber,
            currentTestNumber, contentQuestionCode, contentQuestionType, fromURL } = this.state;
        const filterContent = testContent.filter((ele: any) => ele.attachedQuestions.isJobCompleted)

        let subjectsData = contentRequestData.requestInfo.details.subjects;
        let subjectArr: any = [];
        subjectsData.forEach((subjects: any) => subjectArr.push(
            subjects.name
        ));
        let subjectStr = subjectArr.join(" & ");
        const { count, percentage } = progressBarForTest;
        let totalUnresolvedFeedbackCount = _.get(this.props.contentRequestData, 'requestInfo.details.testDetails.contentRequestItemsId.totalUnresolvedFeedbackCount', 0)

        return (
            <>
                {
                    accordianTest && accordianTest.map((question: any, index: number) => {

                        return (
                            <MyPATExpansionStep
                                // status={filterContent.length !== totalCount ? StepStatus.PENDING : StepStatus.DONE}
                                status={this.handleStatusOfTest(count, totalCount)}
                                title="Create Test"
                                subHeading={totalCount > 1 ? `${totalCount} tests` : `${totalCount} test`}
                                secondarySummaryHeading="Subject"
                                secondarySummary={subjectStr}
                                expanded={false}
                                description={description}
                                taskStatus={!filterContent.length ? true : false}
                                isProgressReq={filterContent.length ? true : false}
                                countProgress={count}
                                overallDone={overallDone}
                                onFeedbackClickFromCreator={() => this.onFeedbackClickFromCreator(this.props.contentRequestData)}
                                totalCountProgress={totalCount}
                                percentage={count / totalCount * 100}
                                totalUnresolvedFeedbackCount={totalUnresolvedFeedbackCount - this.props.removeUnresolvedFeedbackCountForTest}

                            >
                                {this.addTest(type, index)}
                            </MyPATExpansionStep>
                            // </Grid>

                        )
                    })
                }
                {showRequestContainer &&
                    <Modal
                        open={true}
                        classes={{ root: classes.fullModal }}
                        aria-labelledby="simple-modal-title"
                        aria-describedby="simple-modal-description"
                        hideBackdrop={true}
                    >
                        <RequestReviewContainer contentRequestId={this.props.contentRequestData._id} contentId={selectedContentId}
                            sliderData={sliderData} currentQuestionNumber={currentQuestionNumber}
                            contentChanged={this.contentChanged} closeReviewContainer={this.closeReviewContainer}
                            authorType={'creator'}
                            currentTestNumber={currentTestNumber} contentQuestionType={contentQuestionType}
                            contentQuestionCode={contentQuestionCode}
                            fromURL={fromURL} />
                    </Modal>


                }
            </>
        )
    }

}
const mapStateToProps = (state: any) => ({
    accordianState: _.get(state, 'contentRequestData.contentRequestAccordianData.accordianState', []),
    accordianTouched: _.get(state, 'contentRequestData.contentRequestAccordianData.accordianTouched', []),
    accordianCreateTouched: _.get(state, 'contentRequestData.contentRequestAccordianData.accordianCreateTouched', []),
    isComingFromTestComponent: _.get(state, 'contentRequestData.contentRequestAccordianData.isComingFromTestComponent'),
    isTabOpened: _.get(state, 'contentRequestData.contentRequestAccordianData.isTabOpened'),
    progressBarForTest: _.get(state, 'contentRequestData.contentRequestAccordianData.progressBarForTest', {}),
    accordianTest: _.get(state, 'contentRequestData.contentRequestAccordianData.accordianTest', []),
    removeUnresolvedFeedbackCountForTest: _.get(state, 'contentRequestData.contentRequestAccordianData.removeUnresolvedFeedbackCountForTest', 0)
});

const mapDispatchToProps = (dispatch: any) => bindActionCreators({
    setAccordianState: contentRequestAccordianActions.setAccordianState,
    setAccordingTouchIndex: contentRequestAccordianActions.setAccordingTouchIndex,
    setAccordianTouchWhileCreate: contentRequestAccordianActions.setAccordianTouchWhileCreate,
    setIsTabOpened: contentRequestAccordianActions.setIsTabOpened,
    setProgressBarForTest: contentRequestAccordianActions.setProgressBarForTest,
    setTestAccordian: contentRequestAccordianActions.setTestAccordian,
    setRemoveUnresolvedFeedbackCountForTest: contentRequestAccordianActions.setRemoveUnresolvedFeedbackCountForTest,
    setFeedbackClose: contentRequestAccordianActions.setFeedbackClose,

    showMsg: showMsg,
}, dispatch);

export default connect(
    mapStateToProps,
    mapDispatchToProps
    // @ts-ignore
)(withRouter(withStyles(userStyles)((TestComponent))));